import './MenuItem.scss'
import { type MouseEvent, type MouseEventHandler } from 'react'
import classNames from 'classnames'
import { Badge } from '@mui/material'
import Icon from '../../Icon/Icon'
import * as S from './MenuItem.styles'
import { analytics, EVENT_NAMES } from '../../../services/Analytics/Analytics'
import NewBadge from '../../Badge/Badge.styles'
import { type Location } from 'react-router'
import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'

type MenuItemProps = {
  itemId: string
  icon: React.ReactNode
  text: string
  location?: Location | string
  isExternal?: boolean
  target?: string
  onClick?: MouseEventHandler
  highlighted?: boolean
  tag?: number
  chevron?: boolean
  isNew?: boolean
  testId?: string
}

export function MenuItem({
  itemId,
  icon,
  text,
  location,
  isExternal,
  target = '_self',
  onClick,
  highlighted,
  tag = 0,
  chevron,
  isNew,
  testId,
}: MenuItemProps) {
  const classes = classNames('MixtilesMenuItem', { highlighted })
  const { t } = useTranslation()

  const handleClick = (e: MouseEvent) => {
    onClick?.(e)
    if (itemId === 'PROMO_CODE') {
      return
    }
    itemId && analytics.track(EVENT_NAMES.MENU_ITEM_TAPPED, { Item: itemId })
  }

  const menuItemContents = (
    <>
      {icon}
      <S.Text>{text}</S.Text>
      {tag > 0 && (
        <div className="badge">
          <Badge badgeContent={tag} color="primary" />
        </div>
      )}
      {chevron && <Icon className="chevron-icon" icon="greyChevron" />}
      {isNew && <NewBadge $uppercase>{t('general.new')}</NewBadge>}
    </>
  )

  // If location is specified, wrap it in a React Router link
  if (location) {
    return (
      <Link
        style={{ textDecoration: 'none', color: 'unset' }}
        to={isExternal ? (location as string) : (location as Location).pathname}
        state={isExternal ? undefined : (location as Location).state}
        reloadDocument={isExternal}
        target={target}
        className={classes}
        onClick={handleClick}
        data-testid={testId}
      >
        {menuItemContents}
      </Link>
    )
  } else {
    return (
      <div className={classes} onClick={handleClick} data-testid={testId}>
        {menuItemContents}
      </div>
    )
  }
}
